// vendors
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

// styles
import {
  ButtonText,
  ReinviteInput,
  ReinviteButton,
  ReinviteContainer,
  StylesImageModalResultsUpdateMember,
} from './Reinvite.styled';
import RendererIf from 'components/RendererIf';
import ResultActionModal from 'components/shared/ResultActionModal/ResultActionModal';
import updateErrorImage from 'images/error.svg';
import updateSuccessImage from 'images/checked.svg';
import UserService from 'services/UserService';

const userService = UserService.getInstance();

export const Reinvite = ({
  value,
  onBlur,
  onChange,
  fieldName,
  disabledInput,
  onChangeField,
  showReinviteButton = true,
  beforeSendReinvite,
}: any) => {
  const { t: translate } = useTranslation();
  const [disabledButton] = useState(false);
  const [inputChanged, setInputChanged] = useState<any>('');

  const [showResultActionModal, setShowResultActionModal] = useState<any>(
    false,
  );

  const ConfigResultActionModal = {
    success: {
      title: translate('common:SUCCESS'),
      image: updateSuccessImage,
      configPopsModal: {
        showCloseButton: false,
        onClosedModal: () => {
          if (setShowResultActionModal) setShowResultActionModal(false);
        },
      },
    },
    error: {
      title: translate('common:ERROR'),
      image: updateErrorImage,
      configPopsModal: {
        showCloseButton: true,
        onClosedModal: () => {
          if (setShowResultActionModal) setShowResultActionModal(false);
        },
      },
    },
  };

  const [statusResultActionModal, setStatusResultActionModal] = useState<any>(
    ConfigResultActionModal.error,
  );

  const handleCallBackBeforeSendReinvite = () => {
    if(beforeSendReinvite) {
      beforeSendReinvite(inputChanged)
      .finally(() => {
        handleOnClickReinvite();
      });
    } else {
      handleOnClickReinvite();
    }
  }

  const handleOnClickReinvite = () => {
    userService.reinvite(value)
      .then(() => {
        setStatusResultActionModal(ConfigResultActionModal.success);
      })
      .catch((error: any) => {
        setStatusResultActionModal(ConfigResultActionModal.error);
      }).finally(() => {
        setShowResultActionModal(true);
      });
  };

  return (
    <ReinviteContainer showReinviteButton={showReinviteButton}>
      <RendererIf condition={showResultActionModal}>
        <ResultActionModal
          styles={{ Image: StylesImageModalResultsUpdateMember }}
          {...statusResultActionModal}
        />
      </RendererIf>
      <ReinviteInput
        placeholder={translate('EMAIL')}
        name="parentEmail"
        value={value}
        onChange={(v: any) => {
          onChange(v);
          setInputChanged(v);
          onChangeField({ fieldName, selectedValue: v });
        }}
        onBlur={onBlur}
        disabled={disabledInput}
      />
      <ReinviteButton
        flat
        disabled={disabledButton}
        onClick={handleCallBackBeforeSendReinvite}
      >
        <ButtonText>{translate('settings:REINVITE')}</ButtonText>
      </ReinviteButton>
    </ReinviteContainer>
  );
};
